<!-- LoadingModal.vue -->
<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['logout'])
</script>

<template>
  <Teleport to="body">
    <div v-if="isLoading || error" class="modal-overlay">
      <div class="modal-content">
        <div v-if="isLoading" class="loading-container">
          <div class="spinner"></div>
          <p>{{ __DICT__.loadingWeekData }}</p>
        </div>

        <div v-if="error" class="error-container">
          <div class="error-message">{{ error }}</div>
          <button
              @click="emit('logout')"
              class="logout-button"
          >
            {{ __DICT__.tray.logout }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: var(--tblr-bg-surface);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: var(--tblr-box-shadow-lg);
  max-width: 90%;
  width: 400px;
  text-align: center;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--tblr-border-color);
  border-top: 3px solid var(--tblr-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.error-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.error-message {
  color: var(--tblr-danger);
  margin-bottom: 1rem;
}

.logout-button {
  background: var(--tblr-danger);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.logout-button:hover {
  opacity: 0.9;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>